import { FC, ReactNode, PropsWithChildren } from 'react';
import { useMount } from 'react-use';
import { init, BrowserTracing, Replay, ErrorBoundary } from '@sentry/react';
import { ErrorBoundaryContext } from '../../contexts/ErrorBoundary.context';

type ErrorBoundaryProviderProps = PropsWithChildren<{
  dsn: string;
  release?: string;
  environment?: string;
  fallback?: ReactNode;
}>;

export const ErrorBoundaryProvider: FC<ErrorBoundaryProviderProps> = ({
  dsn,
  release,
  environment,
  children,
  fallback = null,
}) => {
  useMount(() => {
    init({
      dsn,
      integrations: [new BrowserTracing(), new Replay()],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      release,
      environment,
      enabled: window.location.hostname !== 'localhost',
    });
  });

  return (
    <ErrorBoundaryContext.Provider value={{ fallback }}>
      <ErrorBoundary fallback={() => <>{fallback}</>}>{children}</ErrorBoundary>
    </ErrorBoundaryContext.Provider>
  );
};
